import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { store } from './app/store';
import { injectStore } from './services/api/api-config';
import App from './containers/App';
import Wrapper from './containers/Wrapper';
import Spinner from "./components/spinner/Spinner";
import ErrorBoundary from './components/common/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import "./assets/css/style.css";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { msalConfig } from "./authConfig";
import runtimeConfig from "./config/runtimeConfig";

injectStore(store);

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
const msalInstance = new PublicClientApplication(msalConfig);

// Si el entorno no define GOOGLE_CLIENT_ID dejamos cadena vacía: el provider monta igual
// (los hooks no fallan) pero el botón de Google queda oculto en el Login.
const googleClientId = runtimeConfig.GOOGLE_CLIENT_ID ?? '';

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <Wrapper>
        <Suspense fallback={<Spinner />}>
          <MsalProvider instance={msalInstance}>
            <GoogleOAuthProvider clientId={googleClientId}>
              <App />
            </GoogleOAuthProvider>
          </MsalProvider>
        </Suspense>
      </Wrapper>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
